import { AccountContext } from "context/account";
import React, { createContext, useContext, useEffect, useRef, useState } from "react";

import api from "../services/api";

const defaultMyProjectsContext = {
  stagesProjects: {
    all: [],
    init: [],
    requested: [],
    active: [],
    completed: [],
    canceled: [],
  },
  prospects: [],
  accountType: null,
  getMyProjects: () => {},
  getMyFavoriteProjects: () => {},
  addMyFavoriteProject: () => {},
  removeMyFavoriteProject: () => {},
  retrieveFavorite: () => {},
  addUnFavoriteProject: () => {},
  handleRefresh: () => {},
};

const MyProjectsContext = createContext(defaultMyProjectsContext);
export default MyProjectsContext;

export const MyProjectsProvider = (props) => {
  const [accountType, setAccountType] = useState(defaultMyProjectsContext.accountType);
  const [stagesProjects, setStagesProjects] = useState(defaultMyProjectsContext.stagesProjects);
  const [prospects, setProspects] = useState(defaultMyProjectsContext.prospects);

  const account = useContext(AccountContext);

  useEffect(() => {
    if (account.id) {
      handleRefresh();
    }
  }, [account.id]);

  const getMyProjects = async (id, account_type) => {
    if (id && account_type == "ma") {
      try {
        const { data } = await api.project.list({ provider_id: id, order: "-updated_at" });
        let project = data["project"] ? data["project"] : [];

        let stagesProjects = {
          all: [],
          active: [],
          completed: [],
          canceled: [],
        };

        for (let i = 0; i < project.length; i++) {
          const status = project[i]?.status;
          if (stagesProjects.hasOwnProperty(status)) {
            stagesProjects[status].push(project[i]);
            stagesProjects["all"].push(project[i]);
          }
        }
        setStagesProjects(stagesProjects);
      } catch (err) {
        console.log(err);
      }
    } else if (id && account_type == "de") {
      try {
        const { data } = await api.project.list({ order: "-updated_at" });
        let project = data["project"] ? data["project"] : [];

        let stagesProjects = {
          all: [],
          init: [],
          requested: [],
          active: [],
          completed: [],
          canceled: [],
        };

        for (let i = 0; i < project.length; i++) {
          const status = project[i]?.status;
          if (stagesProjects.hasOwnProperty(status)) {
            stagesProjects[status].push(project[i]);
            stagesProjects["all"].push(project[i]);
          }
        }
        setStagesProjects(stagesProjects);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getMyFavoriteProjects = async (id, account_type) => {
    if (id && account_type == "ma") {
      try {
        const { data } = await api.project.listFavoriteProjects();
        let projectWithFavorite = data?.project || [];
        setProspects(projectWithFavorite);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const addMyFavoriteProject = async (id, account_type, projectId) => {
    if (id && account_type == "ma") {
      let payload = {
        resource_id: projectId,
        resource_type: "project",
      };

      await api.favorites.create(payload);
      getMyFavoriteProjects(id, account_type);
    }
  };

  const addUnFavoriteProject = async (id, account_type, projectId) => {
    if (id && account_type == "ma") {
      let payload = {
        resource_id: projectId,
        resource_type: "project",
        rating: -10,
      };

      await api.favorites.create(payload);
      getMyFavoriteProjects(id, account_type);
    }
  };

  const removeMyFavoriteProject = async (id, account_type, ufavor_id) => {
    if (id && account_type == "ma") {
      if (!ufavor_id) {
        return toast.error(`Can't find the id!`);
      }

      await api.favorites.delete(ufavor_id);
      getMyFavoriteProjects(id, account_type);
    }
  };

  const retrieveFavorite = async (projectId) => {
    //get favorite information for specific project
    const { data } = await api.favorites.get({ resource_id: projectId, resource_type: "project" });
    return data;
  };

  const handleRefresh = () => {
    if (account.id && account.account_type == "ma") {
      setAccountType("ma");
      getMyProjects(account.id, account.account_type);
      getMyFavoriteProjects(account.id, account.account_type);
    } else if (account.id && account.account_type == "de") {
      setAccountType("de");
      getMyProjects(account.id, account.account_type);
    }
  };

  return (
    <MyProjectsContext.Provider
      {...props}
      value={{
        ...defaultMyProjectsContext,
        accountType,
        stagesProjects,
        prospects,
        getMyProjects,
        getMyFavoriteProjects,
        addMyFavoriteProject,
        removeMyFavoriteProject,
        retrieveFavorite,
        addUnFavoriteProject,
        handleRefresh,
      }}
    />
  );
};
